import React from 'react';
import { getRehydratableName } from '@dcl/ui';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { IHelpCenterSpacer } from './types';
import { spacer } from './constants/index';
import { useMobile } from '../../utils/customHooks/useMobile';

export const HelpCenterSpacer: React.FC<IHelpCenterSpacer> = (props) => {
  const { desktopHeight, mobileHeight } = props;
  const { isMobile } = useMobile();

  const getHeight = () => {
    const height = isMobile ? mobileHeight : desktopHeight;
    const defaultHeight = isMobile
      ? spacer.defaultMobileHeight
      : spacer.defaultDekstopHeight;
    return height
      ? parseFloat(height) / spacer.remConverter + spacer.unit
      : defaultHeight;
  };

  return (
    <div
      data-rehydratable={getRehydratableName(HelpCenterSpacer.displayName)}
      {...propsToDataAttributes(props)}
    >
      <div
        style={{
          height: getHeight(),
        }}
      ></div>
    </div>
  );
};

HelpCenterSpacer.displayName = 'HelpCenterSpacer';
